import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const PROCESS_ROUTER_NODE_DETAILS_FRAGMENT = gql`
  fragment ProcessRouterNodeDetails on ProcessRouterNodeDetailsNode {
    id
    type
    ... on ProcessRouterNodeDetailsNode {
      id
      name
      routerFunctions {
        ... on ProcessRouterFunctionNode {
          id
          name
          edgeConfig {
            id
            fromNodeConfig {
              id
            }
            toNodeConfig {
              id
            }
          }
          isDefault
          expression {
            ... on BenchlingExpressionNode {
              expressionJson
            }
            ...InaccessibleInfoGraphQL
          }
        }
      }
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const PROCESS_TASK_STATUS_FRAGMENT = gql`
  fragment ProcessTaskStatus on ProcessTaskStatusNode {
    id
    displayName
    statusType
  }
`;

export const PROCESS_TASK_STATUS_LIFECYCLE_FRAGMENT = gql`
  fragment ProcessTaskStatusLifecycle on ProcessTaskStatusLifecycleNode {
    id
    schemaExecutionType
    initialStatus {
      ... on ProcessTaskStatusNode {
        ...ProcessTaskStatus
      }
    }
    transitions {
      id
      isAutomatedTransition
      inStatus {
        ... on ProcessTaskStatusNode {
          ...ProcessTaskStatus
        }
      }
      outStatus {
        ... on ProcessTaskStatusNode {
          ...ProcessTaskStatus
        }
      }
    }
  }
  ${PROCESS_TASK_STATUS_FRAGMENT}
`;

export const PROCESS_TASK_FRAGMENT = gql`
  fragment ProcessTask on ProcessTaskNode {
    id
    humanId
    fields
    status {
      ... on ProcessTaskStatusNode {
        ...ProcessTaskStatus
      }
    }
    assignee {
      ... on UserNode {
        id
        handle
        name
        avatarUrl
      }
    }
    executionOrigin {
      ... on ProcessTaskExecutionOriginNode {
        executionType
        executionEntry {
          id
          name
          editUrl
        }
        createdAt
      }
    }
    scheduledOnDate
    ...HasArchiveRecordGraphQL
    ...StudyableTypedValueDataGraphQL
  }
  ${PROCESS_TASK_STATUS_FRAGMENT}
  ${getFragmentWrapper('HasArchiveRecord').fragment}
  ${getFragmentWrapper('StudyableTypedValueData').fragment}
`;

export const PROCESS_TASK_SCHEMA_FRAGMENT: DocumentNode = gql`
  fragment ProcessTaskSchema on ProcessTaskSchemaNode {
    id
    name
    prefix
    fields
    allFields
    archiveRecord {
      purpose
    }
  }
`;

export const TASK_FINDER_LOOKUP_CONFIG_FRAGMENT: DocumentNode = gql`
  fragment TaskFinderLookupConfig on LookupConfigNode {
    id
    isMulti
    multiFlattenLevel
    lookupSteps
  }
`;

export const PROCESS_OUTPUT_SCHEMA_FRAGMENT: DocumentNode = gql`
  fragment ProcessOutputSchema on ProcessOutputSchemaNode {
    id
    name
    prefix
    fields
    allFields
    archiveRecord {
      purpose
    }
    taskFinderLookupConfig {
      ... on LookupConfigNode {
        ...TaskFinderLookupConfig
      }
    }
    processExecutionType
    processTaskSchemaName
  }
  ${TASK_FINDER_LOOKUP_CONFIG_FRAGMENT}
`;
